import { useCallback, useEffect, useMemo, useState } from "react"
import { Button, Dropdown, DropdownButton, Form, Image, Table } from "react-bootstrap"
import "./style.scss"
import NumberFormat from "react-number-format"

import icontransfer from "../../imgs/gcash/item_transfer.png"
import { useDispatch, useSelector } from "react-redux"
import { coRegisterData, coRegisterLoading, coRegisterMessage, getCashoutHistory, getCashoutList } from "../../store/secure/selector"

import * as secureActions from "../../store/secure/actions";
import { getAccessToken } from "../../store/auth/selector"
import { useTranslation } from "react-i18next"
import { getAppInfo, getGateConf } from "../../store/app/selector"

const Cashout = () => {


    const dispath = useDispatch()
    const appInfo = useSelector(state => getAppInfo(state))
    const cashoutData = useSelector(state => getCashoutList(state))
    const cashoutList = useMemo(
        () =>
            (Array.isArray(cashoutData) ? cashoutData : []).filter(
                (item) => Number(item.price) !== 10000
            ),
        [cashoutData]
    )
    const access_token = useSelector(state => getAccessToken(state, appInfo))
    const isLoading = useSelector(state => coRegisterLoading(state));

    const registerErrorMessage = useSelector(state => coRegisterMessage(state))
    const registerData = useSelector(state => coRegisterData(state))
    const cashoutHistory = useSelector(state => getCashoutHistory(state))
    const gateConf = useSelector(state => getGateConf(state))


    const [chip, setChip] = useState(0)
    const [price, setPrice] = useState(0)

    const [gcashid, setGcashid] = useState("")
    const [gcashidRe, setGcashidRe] = useState("")

    const [gmsgRe, setGMsgRe] = useState("")
    const [enable] = useState(true)




    useEffect(() => {
        dispath(secureActions.getCashoutLists(access_token, appInfo, gateConf.apiUrl))
        dispath(secureActions.getCashoutHistory(access_token, appInfo, gateConf.apiUrl))
    }, [appInfo])


    useEffect(() => {

        setGMsgRe(registerErrorMessage === undefined ? "" : registerErrorMessage)
    }, [registerErrorMessage])

    useEffect(() => {
        if (cashoutList.length > 0 && chip == 0) {
            setChip(cashoutList[0].chip)
            setPrice(cashoutList[0].price)
        }
    }, [cashoutList])

    const onGcashIDChange = (event) => {
        setGcashid(event.target.value)
    }
    const onGcashIDReChange = (event) => {
        setGcashidRe(event.target.value)
    }

    const onClickRegisterCashout = useCallback(() => {
        setGMsgRe("")
        if (gcashid === "") {
            setGMsgRe("GcashID not not be blank!")
            return;
        }

        if (gcashid !== gcashidRe) {
            setGMsgRe("GcashID not match!")
            return;
        }



        dispath(secureActions.cashoutRegister(access_token, price, gcashid, "LaroPay_Gcash", appInfo, gateConf.apiUrl))

    })

    const onClickPriceChoose = useCallback((e, item) => {
        setChip(item)
        const row = cashoutList.find((i) => i.chip == item)
        setPrice(row ? row.price : 0)
    }, [cashoutList])

    const { t } = useTranslation('translations');

    return (
        <div id="cashout">
            {isLoading && <div className="loading"></div>}
            {
                enable  && <div className="form">
                    <Form>
                        <Form.Group>
                            <Form.Label>{t('txt21')}</Form.Label>
                            <div className="price">
                                {/* <Nav> */}
                                <DropdownButton title={<NumberFormat
                                    value={chip}
                                    thousandSeparator={true}
                                    displayType={'text'}
                                />}>
                                    {cashoutList.map((item, index) => {
                                        return (
                                            < Dropdown.Item key={item + index} onClick={(e) => onClickPriceChoose(e, item.chip)}>{<NumberFormat
                                                value={item.chip}
                                                thousandSeparator={true}
                                                displayType={'text'}
                                            />}</Dropdown.Item>
                                        )

                                    })
                                    }
                                </DropdownButton>

                                {/* </Nav> */}
                                <div className="transfer">
                                    <Image src={icontransfer} alt="" />
                                </div>
                                <div className="rs">
                                    <NumberFormat
                                        value={price}
                                        suffix={' ₱'}
                                        thousandSeparator={true}
                                        disabled
                                    />
                                </div>
                            </div>
                            <NumberFormat
                                value={price !== 0 ? chip / price : 0}
                                className={'rate'}
                                suffix={' Chips = 1 Peso'}
                                displayType={'text'}
                                thousandSeparator={true}
                                renderText={(value, props) => <div {...props}>{value}</div>}
                            />

                        </Form.Group>
                        <Form.Group className="inp">
                            <Form.Label>{t('txt22')}</Form.Label>
                            <Form.Control onChange={onGcashIDChange}></Form.Control>
                        </Form.Group>
                        <Form.Group className="inp">
                            <Form.Label>{t('txt23')}</Form.Label>
                            <Form.Control isValid={registerData !== undefined} isInvalid={gmsgRe !== ""} onChange={onGcashIDReChange}></Form.Control>

                            {gmsgRe !== undefined && <div className="invalid-feedback">{t(gmsgRe)}</div>}
                            {registerData !== undefined && <Form.Control.Feedback>{registerData}</Form.Control.Feedback>}


                        </Form.Group>

                        <Form.Group>
                            <Button className="smt" type="button" onClick={() => onClickRegisterCashout()}>{t('txt14')}</Button>
                        </Form.Group>

                    </Form>
                </div>
            }


            <div className="history">
                <Table responsive >
                    <thead>
                        <tr>
                            <th>Exchange Time</th>
                            <th>Chip(s)</th>
                            <th>Peso(s)</th>
                            <th>Mobile</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {cashoutHistory.map((item, index) => {
                            return (
                                <tr key={item + index}>
                                    <td>{item.time}</td>
                                    <td><NumberFormat
                                        value={item.chip}
                                        thousandSeparator={true}
                                        displayType={'text'}
                                    /></td>
                                    <td><NumberFormat
                                        value={item.cash}
                                        thousandSeparator={true}
                                        displayType={'text'}
                                    /></td>
                                    <td>{item.gid}</td>
                                    <td className={item.status == "Done" ? "done status" : "status"}>{item.status}</td>
                                </tr>
                            )
                        })}
                    </tbody>
                </Table>
            </div>
        </div >
    );
}

export default Cashout;